import { EntityBindingColumns } from "../metadata/BaseEntityRecordBinding";

export default class NumberFormatter {
    static locales = "en-GB";

    static formatToGBP(value: unknown, maxDecimalDigits = 2) {
        const formatter = Intl.NumberFormat(NumberFormatter.locales, { style: "currency", currency: "GBP", maximumFractionDigits: maxDecimalDigits });
        if (!value) {
            return formatter.format(0);
        }
        const numericValue = Number(value);
        return formatter.format(numericValue);
    }
    static formatByDefaultValue(value: unknown, defaultValue: string) {
        const decimalsLength = defaultValue.split(".")[1]?.length || 2;
        const numericValue = Number(value);
        return Intl.NumberFormat(NumberFormatter.locales, { style: "decimal", maximumFractionDigits: decimalsLength, minimumFractionDigits: decimalsLength }).format(numericValue);
    }

    static formatSquareMeters(value: unknown) {
        const symbol = `\u33A1`;
        return NumberFormatter.formatValueWithSymbol(value, symbol);
    }
    static formatPercent(value: unknown) {
        if (!value) {
            return Intl.NumberFormat(NumberFormatter.locales, { style: "percent", maximumFractionDigits: 2 }).format(0);
        }
        const numericValue = Number(value);
        return Intl.NumberFormat(NumberFormatter.locales, { style: "percent", maximumFractionDigits: 2 }).format(numericValue / 100);
    }
    static formatMinutes(value: unknown) {
        return NumberFormatter.formatValueWithSymbol(value, "min.");
    }
    static formatMeters(value: unknown) {
        return NumberFormatter.formatValueWithSymbol(value, "m");
    }
    static formatKilometers(value: unknown) {
        return NumberFormatter.formatValueWithSymbol(value, "Km");
    }
    static formatAcres(value: unknown) {
        return NumberFormatter.formatValueWithSymbol(value, "acre");
    }
    static formatHectares(value: unknown) {
        return NumberFormatter.formatValueWithSymbol(value, "ha");
    }
    static formatRecordNumbers(recordObj: any, entityMap: Map<string, EntityBindingColumns<any>>, relEntity = "") {
        if (!recordObj) {
            return null;
        }
        const columns = entityMap.get(relEntity);
        if (!columns) {
            return recordObj;
        }
        const keys = Object.keys(recordObj);
        for (const key of keys) {
            const colDef = columns[key];
            if (!colDef) {
                if (entityMap.has(key)) {
                    recordObj[key] = this.formatRecordNumbers(recordObj[key], entityMap, key);
                } else {
                    continue;
                }
            }
            if (colDef.contentType === "LOOKUP" && colDef.relatedObject && recordObj[key]) {
                const relatedRecordProp = key + "_relatedRecord";
                recordObj[relatedRecordProp] = this.formatRecordNumbers(recordObj[relatedRecordProp], entityMap, colDef.relatedObject);
            }
            if (colDef.contentType === "NUMBER" && colDef.defaultValue) {
                if (recordObj[key] !== null) {
                    recordObj[key] = NumberFormatter.formatByDefaultValue(recordObj[key], colDef.defaultValue);
                }
            }
            if (colDef.contentType === "CHECKBOX") {
                if (recordObj[key] !== null) {
                    recordObj[key] = recordObj[key] === 1 || recordObj[key] === "1" ? "Yes" : "No";
                } else {
                    recordObj[key] = "";
                }
            }
        }
        return recordObj;
    }
    private static formatValueWithSymbol(value: unknown, symbol: string) {
        if (!value) {
            return `0 ${symbol}`;
        }
        const numericValue = Number(value);
        return `${numericValue} ${symbol}`;
    }

    /**
     *
     * @returns Casted value or 0 if number is null or undefined
     */
    static castNumber(val: number | null | undefined | unknown): number {
        const castedVal = Number(val);
        if (typeof castedVal === "number" && !isNaN(castedVal)) {
            return castedVal;
        }
        return 0;
    }
    static formatToYesNo(value: unknown, defaultValue = "No") {
        if (!value) {
            return defaultValue;
        }
        const numericValue = Number(value);
        return numericValue === 1 ? "Yes" : "No";
    }
}
